<div class="w-full max-w-md">
  <!-- Header -->
  <div class="p-6 pb-4">
    <div class="flex items-center gap-4">
      <div class="w-14 h-14 rounded-2xl flex items-center justify-center"
           [ngClass]="{
             'bg-emerald-100 dark:bg-emerald-900/30': data.isAuthorized,
             'bg-red-100 dark:bg-red-900/30': !data.isAuthorized
           }">
        <mat-icon class="icon-size-7"
                  [ngClass]="{
                    'text-emerald-600 dark:text-emerald-400': data.isAuthorized,
                    'text-red-600 dark:text-red-400': !data.isAuthorized
                  }"
                  [svgIcon]="data.isAuthorized ? 'tabler_outline:circle-check' : 'tabler_outline:circle-x'"></mat-icon>
      </div>
      <div>
        <h2 class="text-xl font-bold text-gray-900 dark:text-white">
          {{ data.isAuthorized ? 'Połączenie aktywne' : 'Brak połączenia' }}
        </h2>
        <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
          {{ data.isAuthorized ? 'Twoje konto jest połączone z KSeF' : 'Nie udało się nawiązać połączenia' }}
        </p>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="px-6 pb-6">
    <!-- Success state -->
    <div *ngIf="data.isAuthorized" class="space-y-4">
      <!-- NIP -->
      <div *ngIf="data.nip" class="flex items-center gap-3 p-3 rounded-xl bg-gray-50 dark:bg-gray-800/50">
        <mat-icon class="icon-size-5 text-gray-400" [svgIcon]="'tabler_outline:building'"></mat-icon>
        <div>
          <p class="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">NIP</p>
          <p class="font-semibold text-gray-900 dark:text-white">{{ data.nip }}</p>
        </div>
      </div>

      <!-- Permissions -->
      <div *ngIf="data.permissions?.length">
        <p class="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Uprawnienia</p>
        <div class="flex flex-wrap gap-2">
          <span *ngFor="let permission of data.permissions"
                class="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300">
            <mat-icon class="icon-size-4" [svgIcon]="'tabler_outline:check'"></mat-icon>
            {{ translatePermission(permission) }}
          </span>
        </div>
      </div>

      <!-- Required permissions check -->
      <div *ngIf="data.permissions" class="p-3 rounded-xl" 
           [ngClass]="{
             'bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800': hasRequiredPermissions(),
             'bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800': !hasRequiredPermissions()
           }">
        <div class="flex items-start gap-3">
          <mat-icon class="icon-size-5 mt-0.5"
                    [ngClass]="{
                      'text-emerald-600 dark:text-emerald-400': hasRequiredPermissions(),
                      'text-amber-600 dark:text-amber-400': !hasRequiredPermissions()
                    }"
                    [svgIcon]="hasRequiredPermissions() ? 'tabler_outline:shield-check' : 'tabler_outline:alert-triangle'"></mat-icon>
          <div>
            <p class="font-medium"
               [ngClass]="{
                 'text-emerald-800 dark:text-emerald-300': hasRequiredPermissions(),
                 'text-amber-800 dark:text-amber-300': !hasRequiredPermissions()
               }">
              {{ hasRequiredPermissions() ? 'Wszystkie wymagane uprawnienia' : 'Brakuje wymaganych uprawnień' }}
            </p>
            <ng-container *ngIf="hasRequiredPermissions()">
              <p class="text-sm mt-0.5 text-emerald-700 dark:text-emerald-400">
                Posiadasz uprawnienia do odczytu i tworzenia faktur.
              </p>
            </ng-container>
            <ng-container *ngIf="!hasRequiredPermissions()">
              <p *ngIf="!hasInvoiceWritePermission()" class="text-sm mt-1 text-amber-700 dark:text-amber-400">
                • Brak uprawnienia do wysyłki faktur (InvoiceWrite)
              </p>
              <p *ngIf="!hasInvoiceReadPermission()" class="text-sm mt-1 text-amber-700 dark:text-amber-400">
                • Brak uprawnienia do pobierania faktur (InvoiceRead)
              </p>
              <p class="text-sm mt-2 text-amber-600 dark:text-amber-500" *ngIf="isCertificateConnection">
                Uprawnienia nie są zaszyte w certyfikacie — nadaj brakujące uprawnienia w KSeF.
              </p>
              <p class="text-sm mt-2 text-amber-600 dark:text-amber-500" *ngIf="!isCertificateConnection">
                Wygeneruj nowy token z odpowiednimi uprawnieniami.
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Error state -->
    <div *ngIf="!data.isAuthorized" class="space-y-4">
      <div *ngIf="data.lastError" class="p-4 rounded-xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
        <div class="flex items-start gap-3">
          <mat-icon class="icon-size-5 text-red-600 dark:text-red-400 mt-0.5" [svgIcon]="'tabler_outline:alert-circle'"></mat-icon>
          <div>
            <p class="font-medium text-red-800 dark:text-red-300">Błąd połączenia</p>
            <p class="text-sm text-red-700 dark:text-red-400 mt-1">{{ data.lastError }}</p>
            <p *ngIf="data.lastErrorAt" class="text-xs text-red-600/70 dark:text-red-500/70 mt-2">
              {{ data.lastErrorAt | date: 'dd.MM.yyyy, HH:mm:ss' }}
            </p>
          </div>
        </div>
      </div>

      <div class="p-4 rounded-xl bg-gray-50 dark:bg-gray-800/50">
        <p class="text-sm text-gray-600 dark:text-gray-400">
          <strong>Możliwe przyczyny:</strong>
        </p>
        <ul class="mt-2 text-sm text-gray-600 dark:text-gray-400 space-y-1">
          <li class="flex items-start gap-2">
            <span class="text-gray-400">•</span>
            Wprowadziłeś nieprawidłowe hasło klucza prywatnego
          </li>
          <li class="flex items-start gap-2">
            <span class="text-gray-400">•</span>
            Wybrałeś niewłaściwe przeznaczenie certyfikatu 
          </li>
          <li class="flex items-start gap-2">
            <span class="text-gray-400">•</span>
            Wybrałeś certyfikat offline, który nie jest przeznaczony do komunikacji z KSeF 
          </li>
          <li class="flex items-start gap-2">
            <span class="text-gray-400">•</span>
            Problemy z serwerem KSeF
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="px-6 pb-6 flex justify-end">
    <button mat-flat-button color="primary" (click)="close()">
      Zamknij
    </button>
  </div>
</div>
